
    import {PageRequest} from '@/store/shared/entity'
    import CreateEstimatedExchangeRate from './component/create-estimated-exchange-rate.vue'
    import EditEstimatedExchangeRate from './component/edit-estimated-exchange-rate.vue'
    import { Component, Mixins, ActionButtonConfig, PageResultBaseMixins, PageResultModalMixins } from "@/lib";

    class  PageEstimatedExchangeRateRequest extends PageRequest{
        year:Date;
        dateTime:Date;
    }

    @Component({
 name: "estimatedexchangerate",
        components:{CreateEstimatedExchangeRate,EditEstimatedExchangeRate}
    })
    export default class EstimatedExchangeRate extends  Mixins(PageResultBaseMixins,PageResultModalMixins){
        buttons = { ...this.addBtn() };

        data:any = {
            model: new PageEstimatedExchangeRateRequest(),
            queryAction:"system/estimatedexchangerate/getAll",
            isAutoQuery: true,
            cols:this.columns
        }

        get columns(){
            return [
                this.$util.render.dateMonthColumn(
                 "app.EstimatedExchangeRate.Month",
                 "month",
                 { width: 600 }
                ),
                { title:this.L('app.EstimatedExchangeRate.EstimatedExchangeRates'), key:'estimatedExchangeRates' },
                this.$util.render.actions(this.colButtons)
            ]
        }

        colButtonCheck = (row) => {
            return !row.isStatic;
        }

        get colButtons():ActionButtonConfig[]{ 
            return [
                this.colEditBtnM(row => this.colButtonCheck(row)),
                this.colDeleteBtn( row => this.colButtonCheck(row)),
            ]
        }

        async created(){
        }

        reset(){
            this.data.model = new PageEstimatedExchangeRateRequest();
        }
    }
